const optionIdentifier = function optionIdentifier() {
  let option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const keys = Object.keys(option);
  if (keys.length === 0) {
    return undefined;
  }
  return keys[0];
};

/**
  * @function evalute - evaluate signatureValidationBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, evaluator) => {
  const signaturesCollection = await evaluator(source.collection);
  const validInspectorTypes = await evaluator(source.validInspectorTypes);
  if (!signaturesCollection) {
    return undefined;
  }
  const keys = Object.keys(signaturesCollection);
  return keys.some(key => {
    const item = signaturesCollection[key];
    const hasRemotePath = item.remotePath !== undefined;
    const hasInspectorTypes = validInspectorTypes.includes(optionIdentifier(item.inspectorType));
    return hasRemotePath && hasInspectorTypes;
  });
};
module.exports = {
  evaluate
};